export class SearchBoldValueConverter {
    toView(value, searchTerm, filterStartCharCount, filterSearchFunction) {
        if (!searchTerm || searchTerm.length < filterStartCharCount) return value;
        switch (filterSearchFunction) {
            case 'startsWith':
                return value.replace(new RegExp('^' + searchTerm, 'gi'), `<b>$&</b>`);
                break;
            case 'includes':
            default:
                var res = value.replace(new RegExp(searchTerm, 'gi'), `<b>$&</b>`);
                return res;
                break;
        }
    }
}
